import { ActionReducer, Action } from '@ngrx/store';
import { initialOpbCompanyListState, IOpbCompanyListState } from '../states/opb-company-list.state';
import { EOpbCompanyListActions, SetOpbCompanySearchFilter, SetOpbCompanyPagination, SetOpbCompanySort } from '../actions/opb-company-list.actions';
import { EActiveYearActions } from '../actions/active-year.actions';

export const opbCompanyListReducers: ActionReducer<IOpbCompanyListState, Action<string>> = (
  state = initialOpbCompanyListState,
  action: Action<string>
) => {
  switch (action.type) {
    case EOpbCompanyListActions.SetSearchFilter: {
      const typedAction = action as SetOpbCompanySearchFilter;
      return {
        ...state,
        searchFilter: typedAction.payload,
        currentPage: 1
      };
    }

    case EOpbCompanyListActions.SetPagination: {
      const typedAction = action as SetOpbCompanyPagination;
      return {
        ...state,
        currentPage: typedAction.payload.currentPage,
        pageSize: typedAction.payload.pageSize
      };
    }

    case EOpbCompanyListActions.SetSort: {
      const typedAction = action as SetOpbCompanySort;
      return {
        ...state,
        sortBy: typedAction.payload.sortBy,
        ascending: typedAction.payload.ascending
      };
    }

    case EOpbCompanyListActions.ClearFilters: {
      return {
        ...initialOpbCompanyListState
      };
    }

    case EActiveYearActions.Changed: {
      const { measurement: _dropped, ...rest } = state.searchFilter;
      return {
        ...state,
        searchFilter: rest
      };
    }

    default:
      return state;
  }
};
